import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Pulsing placeholder block (shadcn/ui skeleton primitive). Size it with
 * width/height utilities via `className`.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div aria-hidden className={cn("animate-pulse rounded-md bg-gray-200", className)} {...props} />
	);
}

export { Skeleton };
